import React, {FC} from 'react'

import {theme} from '../theme/theme'

type Icon = FC<{
  color?: keyof typeof theme.colors
  withBorder?: boolean
  w?: number
  h?: number
}>

export const GoogleIcon: Icon = ({w, h}) => (
  <svg
    width={w || 24}
    height={h || 24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask
      id='mask0_22251_12419'
      style={{maskType: 'alpha'}}
      maskUnits='userSpaceOnUse'
      x='2'
      y='2'
      width='20'
      height='20'
    >
      <path
        d='M12.1789 2.00839C14.6914 1.89369 17.0532 2.96779 18.9775 4.47649C18.1562 5.39335 17.3057 6.27652 16.3971 7.10251C14.0838 5.53187 10.7939 5.08297 8.48063 6.89729C5.17139 9.14588 5.0207 14.4551 8.20385 16.8756C11.2993 19.6353 16.9665 18.308 17.9643 14.5C16.2749 14.4714 13.9165 14.5619 11.9777 14.5C11.9728 13.3636 11.9728 11.886 11.9777 10.75C15.219 10.7405 18.7092 10.7258 21.9554 10.75C22.1497 13.4237 21.7425 16.0975 20.0707 18.308C17.5389 21.8077 12.456 22.8294 8.49033 21.3302C4.51044 19.8405 1.69172 15.7106 2.02704 11.4996C2.11469 6.34799 6.9353 1.83652 12.1789 2.00839Z'
        fill='#2C2D2E'
      />
    </mask>
    <g mask='url(#mask0_22251_12419)'>
      <path
        d='M0 18.5V5.5L8.5 12L0 18.5Z'
        fill='#FBBC05'
      />
      <path
        d='M0 5.5L8.5 12L12 8.95L24 7V0H0V5.5Z'
        fill='#EA4335'
      />
      <path
        d='M0 18.5L15 7L18.95 7.5L24 0V24H0V18.5Z'
        fill='#34A853'
      />
      <path
        d='M24 24L8.5 12L6.5 10.5L24 5.5V24Z'
        fill='#4285F4'
      />
    </g>
  </svg>
)
